import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { card } from './card.json';

const CardContainer = styled.div`
  border: ${({ theme, tokens, withBorder }) =>
    !withBorder
      ? 'none'
      : `${theme.borderWidth(tokens['shape-border-width'])} solid ${theme.color(
          tokens['shape-border-color'],
        )}`};
  width: 100%;
  height: 100%;
  border-radius: ${({ theme, tokens }) =>
    theme.borderRadius(tokens['shape-corner-radius'])};
  background-color: ${({ theme, tokens }) =>
    theme.color(tokens['shape-color'])};
  box-shadow: ${({ theme, tokens, withShadow }) =>
    !withShadow ? 'none' : theme.boxShadow(tokens.shadow)};
`;

// eslint-disable-next-line react/display-name
const CardComponent = React.forwardRef(
  ({ withShadow, withBorder, children, ...props }, ref) => {
    const tokens = card.categories['card-default'].shared;
    return (
      <CardContainer
        ref={ref}
        withShadow={withShadow}
        withBorder={withBorder}
        tokens={tokens}
        {...props}
      >
        {children}
      </CardContainer>
    );
  },
);

CardComponent.defaultProps = {
  withShadow: true,
  withBorder: true,
};

CardComponent.propTypes = {
  children: PropTypes.node,
  withShadow: PropTypes.bool,
  withBorder: PropTypes.bool,
};

CardComponent.displayName = 'CardContainer';

export default CardComponent;
